let ColorPalette = {
  light: {
    background: {
      default: "#fff", // Change the background color for dark mode
    },
    primary: {
      main: "#4238CA",
      light: "#EEF2FF",
      contrastText: "#fff",
    },
    secondary: {
      main: "#7642af",
      light: "#EEFAF6",
      contrastText: "#fff",
    },
    success: {
      main: "#35b522",
      light: "#F0FAE8",
      contrastText: "#fff",
    },
    info: {
      main: "#1e88e5",
      light: "#e7f6fe",
      contrastText: "#fff",
    },
    warning: {
      main: "#e7bb1d",
      light: "#eee3bf",
      contrastText: "#fff",
    },
    error: {
      main: "#F23836",
      light: "#FFEBEB",
      contrastText: "#fff",
    },
    text: {
      main: "#343E54",
      light: "#555555",
      fade: "#969696",
      contrastText: "#fff",
      bg: "#F9FAFB",
    },
    border: {
      main: "#E5E5E5",
    },
  },
  dark: {
    background: {
      default: "#111", // Change the background color for dark mode
    },
    primary: {
      main: "#00A1A1",
      light: "#016363",
      contrastText: "#fff",
    },
    secondary: {
      main: "#770332",
      light: "#380117",
      contrastText: "#fff",
    },
    success: {
      main: "#69CB1C",
      light: "#132603",
      contrastText: "#fff",
    },
    info: {
      main: "#5780FF",
      light: "#050E28",
      contrastText: "#fff",
    },
    warning: {
      main: "#FFC700",
      light: "#271F02",
      contrastText: "#fff",
    },
    error: {
      main: "#FF3938",
      light: "#370C0C",
      contrastText: "#fff",
    },
    text: {
      main: "#DEDEDE",
      light: "#BBBBBB",
      fade: "#555555",
      contrastText: "#fff",
    },
    border: {
      main: "#333333",
    },
  },
};
export default ColorPalette;
